import React from "react";

import { Button } from "@lululemon/ui-library";
import { log } from "@lululemon/mwa-utils";

import IconClose from "@lululemon/ecom-common/src/assets/img/svg/close.svg";
import Icon from "@lululemon/ecom-common/src/components/widgets/icon";

import classNames from "classnames";

import PropTypes from "prop-types";

import useParseContext from "../../hooks/useParseContext";

import styles from "./mobile-facet-wrapper.module.scss";

//COLLECTION DESCRIPTION SUBTITLES AB FLAG TITLES
import { collectionMockDescription } from "../../../../containers/category-page/data/cdp-collection-description";

const MobileFacetWrapper = React.memo(
  ({
    title,
    abTestCollectionSubtitle,
    removeAction,
    pillDataLength,
    facetData,
    children,
  }) => {
    const {
      isMobileFilterOpen: isMobileFilterOpenCDPCtx,
      toggleMobileFilter: toggleMobileFilterCDPCtx,
      totalCurrentProducts: totalCurrentProductsCDPCtx,
      trackFilterClick,
      isTabletOrBelow,
      collectionExplainerABFlag,
      mensCollections,
    } = useParseContext();

    // The SearchContext HOC is not available in SERP, so useParseContext cannot be used for SERP.
    // extraFacetNavProps is used exclusively for the SERP to override useParseContext values.
    const { extraFacetNavProps } = facetData;

    const {
      isMobileFacetNavOpen,
      totalProductsCount,
      onToggleMobileFacetNavClick,
    } = extraFacetNavProps || {};

    const isMobileFilterOpen = isMobileFilterOpenCDPCtx || isMobileFacetNavOpen;
    const totalCurrentProducts =
      totalCurrentProductsCDPCtx || totalProductsCount;
    const toggleMobileFilter =
      toggleMobileFilterCDPCtx || onToggleMobileFacetNavClick;

    const subtitle = mensCollections;

    const mockedForABTest =
      collectionExplainerABFlag &&
      collectionMockDescription?.[abTestCollectionSubtitle];

    try {
      const totalNumberOfProducts =
        totalCurrentProducts > 0 ? `(${totalCurrentProducts})` : "";

      return (
        <>
          <button
            className={classNames(styles.mobileFilterOverlay, "OneLinkTx", {
              [styles.mobileFilterOverlayOpened]: isMobileFilterOpen,
            })}
            onClick={toggleMobileFilter}
            type="button"
            data-testid="mobile-filter-button"
          />
          <div
            className={classNames(styles.facetWrapper, {
              [styles.mobileFilterOverlayOpened]: isMobileFilterOpen,
            })}
          >
            <button
              type="button"
              className={classNames(styles.filterDismissButton, "hide-lg")}
              onClick={toggleMobileFilter}
              aria-label="close"
              data-testid="mobile-filter-close-icon"
            >
              <Icon
                glyph={IconClose}
                className={styles.filterDismissMobileIcon}
              />
            </button>
            <div
              className={classNames(styles.mobileFilterTitleWrapper, "hide-lg")}
            >
              <div
                className={classNames(
                  styles.mobileTitle,
                  "lll-text-xsmall",
                  "OneLinkTx"
                )}
              >
                {title}
              </div>
              {mockedForABTest && ( //AB Test Subtitle for collection filter
                <p className={styles.categorySubtitle}>
                  {collectionMockDescription?.[abTestCollectionSubtitle]}
                </p>
              )}
            </div>
            {children}
            <div
              className={classNames(styles.mobileOverlayButtonContainer, {
                "hide-lg": !isTabletOrBelow,
              })}
            >
              <Button
                data-testid="view-items-btn"
                type="button"
                variant="filled"
                className={classNames(styles.mobileOverlayButton, "OneLinkTx")}
                onClick={() => {
                  trackFilterClick({
                    totalNumberOfProducts: totalCurrentProducts,
                  });
                  toggleMobileFilter();
                }}
              >
                {`View Items ${totalNumberOfProducts}`}
              </Button>
            </div>
          </div>
        </>
      );
    } catch (e) {
      log.error("Error Rendering MobileFacetWrapper", e);
      return null;
    }
  }
);

export default MobileFacetWrapper;

MobileFacetWrapper.displayName = "MobileFacetWrapper";

MobileFacetWrapper.defaultProps = {
  children: null,
  facetData: {},
};

MobileFacetWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};
